const defaultRadius = 10;

export const roundRect = function (ctx: CanvasRenderingContext2D, x: number, y: number, width: number, height: number, radius: number = defaultRadius, fill: any = false, strokeStyle: any = false, lineWidth: any = false, fillStyle: any = false) {
  if (width < 2 * radius) radius = width / 2;
  if (height < 2 * radius) radius = height / 2;
  ctx.save();
  ctx.beginPath();
  ctx.moveTo(x + radius, y);
  ctx.arcTo(x + width, y, x + width, y + height, radius);
  ctx.arcTo(x + width, y + height, x, y + height, radius);
  ctx.arcTo(x, y + height, x, y, radius);
  ctx.arcTo(x, y, x + width, y, radius);
  ctx.closePath();
  if (strokeStyle) {
    ctx.strokeStyle = strokeStyle;
  }
  if (lineWidth) {
    ctx.lineWidth = lineWidth;
  }
  ctx.stroke();
  if (fill) {
    if (fillStyle) {
      ctx.fillStyle = fillStyle
    }
    ctx.fill();
  }
  ctx.restore();
  // return ctx;
}

export const diamond = (ctx: CanvasRenderingContext2D, x: number, y: number, width: number, height: number, fill = false, strokeStyle: any = false, lineWidth: any = false, fillStyle: any = false) => {

  const centerX = x + width / 2;
  const centerY = y + height / 2;

  // Dibujar el rombo
  ctx.beginPath();
  ctx.moveTo(centerX, centerY - height/2); // Punto superior
  ctx.lineTo(centerX + width/2, centerY); // Punto derecho
  ctx.lineTo(centerX, centerY + height/2); // Punto inferior
  ctx.lineTo(centerX - width/2, centerY); // Punto izquierdo
  ctx.closePath();

  // Establecer el color de relleno y dibujar el rombo
  // ctx.fillStyle = "red";
  if (fill) {
    if (fillStyle) {
      ctx.fillStyle = fillStyle
    }
    ctx.fill();
  }

  // Establecer el color de borde y dibujar el contorno del rombo
  if (strokeStyle) {
    ctx.strokeStyle = strokeStyle;
  }
  if (lineWidth) {
    ctx.lineWidth = lineWidth;
  }
  ctx.stroke();
}

export const drawArrow = (ctx: CanvasRenderingContext2D, x1: number, y1: number, x2: number, y2: number) => {

  // Calcular la dirección y la longitud de la flecha
  const dx = x2 - x1;
  const dy = y2 - y1;
  const angle = Math.atan2(dy, dx);
  const length = Math.sqrt(dx * dx + dy * dy);

  // Dibujar la línea principal
  ctx.beginPath();
  ctx.moveTo(x1, y1);
  ctx.lineTo(x2, y2);
  ctx.closePath();
  ctx.stroke();

  // Dibujar la cabeza de la flecha
  ctx.save();
  ctx.translate(x2, y2);
  ctx.rotate(angle);

  ctx.beginPath();
  ctx.moveTo(0, 0);
  ctx.lineTo(-10, -5);
  ctx.lineTo(-10, 5);
  ctx.closePath();
  ctx.fill();

  ctx.restore();
}

export const getMouseCoords = (canvas: any, event: any, scale = 1) => {
  let canvasCoords = canvas.getBoundingClientRect()
  const ret = {
    x: event.clientX - canvasCoords.left,
    y: event.clientY - canvasCoords.top
    // x: event.pageX - canvasCoords.left,
    // y: event.pageY - canvasCoords.top
  };
  return ret;
}

export const getOffsetCoords = (mouse: any, rect: any) => {
  return {
      x: mouse.x - rect.x,
      y: mouse.y - rect.y
  }
}

export const cursorInRect = (mouseX: number, mouseY: number, rectX: number, rectY: number, rectW: number, rectH: number) => {
  let xLine = mouseX >= rectX && mouseX <= (rectX + rectW)
  let yLine = mouseY >= rectY && mouseY <= (rectY + rectH)

  return xLine && yLine;
}

export function splitPhrase(phrase: string): string[] {
  // Encontrar el espacio más cercano al medio de la phrase
  const longitud = phrase.length;
  let espacioMasCercano = -1;
  let distanciaMinima = Infinity;

  for (let i = 0; i < longitud; i++) {
    if (phrase[i] === ' ') {
      const distancia = Math.abs(i - longitud / 2);
      if (distancia < distanciaMinima) {
        espacioMasCercano = i;
        distanciaMinima = distancia;
      }
    }
  }

  // Dividir la phrase en dos partes en función del espacio encontrado
  let part1 = '';
  let part2 = '';

  if (espacioMasCercano !== -1) {
    part1 = phrase.substring(0, espacioMasCercano);
    part2 = phrase.substring(espacioMasCercano + 1);
  } else {
    // Si no se encontró un espacio, dividir la phrase en el medio
    part1 = phrase.substring(0, Math.floor(longitud / 2));
    part2 = phrase.substring(Math.floor(longitud / 2));
  }

  return [part1, part2];
}

export function snakeCaseToHumanReadable(snakeCaseString: string): string {
  const words = snakeCaseString.split('_'); // Divide la cadena por el carácter de subrayado.
  if (words.length === 0) return ''; // Si no hay palabras, retorna una cadena vacía.

  // Capitaliza la primera palabra y deja las demás en minúsculas
  const firstWord = words[0].charAt(0).toUpperCase() + words[0].slice(1).toLowerCase();
  const restWords = words.slice(1).map(word => word.toLowerCase());

  // Une la primera palabra capitalizada con las demás palabras en minúsculas, separándolas por un espacio
  return [firstWord, ...restWords].join(' ');
}
